export default __webpack_public_path__ + "static/media/chelsea3.0b5dcb74.jpg";